<template>
  <div>
    <div class="title">
      Articles
      <span class="conti clickable">
        >
        <img :src="getUrlCountry()" />
      </span>
      <span class="conti clickable" @click="goToCurrentCountry()">{{getCurrentCountry.name + " "}}</span>
      <span class="conti clickable" @click="goToCurrentContinent()">> {{getCurrentContinent.name}}</span>
    </div>
    <simplebar class="articlesContainer simple" data-simplebar-auto-hide="false">
      <div
        :key="index"
        v-for="(c,index) in getCurrentCountry.articles"
        class="cardArticle md-layout clickable"
        @click="goToArticle(c)"
      >
        <div class="md-layout-item md-size-100 cardArticleDate">{{toDate(c.date)}}</div>
        <div
          class="md-layout-item md-size-100 cardArticleHeader"
          :style="{ 'background-image' : getUrl(c) }"
        ></div>
        <div class="articleHolder md-layout-item md-layout md-size-100 cardArticleContent">
          <div class="md-layout-item md-size-100">
            <b>{{c.title}}</b>
          </div>
          <div class="md-layout-item md-size-100">{{c.desc}}</div>
        </div>
      </div>
    </simplebar>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import * as moment from "moment";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";

moment.locale("fr");
export default {
  components: {
    simplebar
  },
  computed: {
    ...mapGetters(["getCurrentCountry", "getCurrentContinent"])
  },
  methods: {
    ...mapActions([
      "setCurrentArticle",
      "resetCurrentCountry",
      "resetCurrentContinent"
    ]),
    goToCurrentCountry() {
      this.$router.push("countries");
    },
    goToCurrentContinent() {
      this.$router.push("/map");
    },
    goToArticle(art) {
      this.setCurrentArticle(art);
      this.$router.push("/article");
    },
    getUrl(c) {
      return `url('${c.image}')`;
    },
    getUrlCountry() {
      return `https://www.countryflags.io/${this.getCurrentCountry.country.toLowerCase()}/flat/16.png`;
    },
    toDate(ms) {
      return moment(ms).format("Do MMM YY");
    }
  }
};
</script>

<style>
.articlesContainer {
  max-height: 84vh;
  width: 400px;
  background-color: rgba(1, 1, 1, 0.2);
}
.cardArticle {
  background-color: white;
  margin: 20px;
  width: 300px !important;
  color: black;
  border-radius: 7px;
  padding: 0 !important;
}
.cardArticleHeader {
  background-size: cover;
  background-position: center;
  height: 70px;
}
.cardArticleContent {
  background-color: black;
  text-align: left;
  padding: 10px;
  background-color: #046380 !important;
  color: #efecca !important;
}
.articleHolder {
  width: 100%;
  color: white;
}

.cardArticleDate {
  border-radius: 7px 7px 0 0;
  padding-right: 5px;
  text-align: right;
  background-color: #046380 !important;
  color: #efecca !important;
}

@media only screen and (max-width: 959px) {
  .articlesContainer {
    max-height: 84vh;
    width: 100%;
    background-color: rgba(1, 1, 1, 0.2);
  }

  .cardArticle {
    width: 80% !important;
    margin-left: 10%;
    margin-right: 10%;
  }
}
</style>